<!-- 热区图片 -->
<template>
    <div>
        <div v-if="new_data.content.imgList !== undefined">
            <div v-if="new_data.content.style_id == 0" :style="`height: ${new_data.content.height}px;`">
                <div :style="`width: 100%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[0].picview"/>
                </div>
            </div>
            <div v-if="new_data.content.style_id == 1" :style="`height: ${new_data.content.height}px;display: flex;`">
                <div :style="`width: 40%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[0].picview"/>
                </div>
                <div :style="`width: 60%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[1].picview"/>
                </div>
            </div>
            <div v-if="new_data.content.style_id == 2" :style="`height: ${new_data.content.height}px;display: flex;`">
                <div :style="`width: 40%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[0].picview"/>
                </div>
                <div :style="`width: 60%;height: ${new_data.content.height}px;`">
                    <div
                        :style="`width: 100%;height: ${new_data.content.height / 2}px;`"
                    >
                        <img class="width_height_100" :src="new_data.content.imgList[1].picview"/>
                    </div>
                    <div
                        :style="`width: 100%;height: ${new_data.content.height / 2}px;`"
                    >
                        <img class="width_height_100" :src="new_data.content.imgList[2].picview"/>
                    </div>
                </div>
            </div>
            <div v-if="new_data.content.style_id == 3" id="parentId" :style="`height: ${new_data.content.height}px;display: flex;`">
                <div :style="`width: 40%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[0].picview"/>
                </div>
                <div :style="`width: 60%;height: ${new_data.content.height}px;`">
                    <div
                        :style="`width: 100%;height: ${new_data.content.height / 2}px;`"
                    >
                        <img class="width_height_100" :src="new_data.content.imgList[1].picview"/>
                    </div>
                    <div class="display_flex">
                        <div
                            :style="`width: 50%;height: ${new_data.content.height / 2}px;`"
                        >
                            <img class="width_height_100" :src="new_data.content.imgList[2].picview"/>
                        </div>
                        <div
                            :style="`width: 50%;height: ${new_data.content.height / 2}px;`"
                        >
                            <img class="width_height_100" :src="new_data.content.imgList[3].picview"/>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="new_data.content.style_id == 4" :style="`height: ${new_data.content.height}px;display: flex;`">
                <div :style="`width: 50%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[0].picview"/>
                </div>
                <div :style="`width: 50%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[1].picview"/>
                </div>
            </div>
            <div v-if="new_data.content.style_id == 5" :style="`height: ${new_data.content.height}px;display: flex;`">
                <div :style="`width: 33.3%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[0].picview"/>
                </div>
                <div :style="`width: 33.3%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[1].picview"/>
                </div>
                <div :style="`width: 33.3%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[2].picview"/>
                </div>
            </div>
            <div v-if="new_data.content.style_id == 6" :style="`height: ${new_data.content.height}px;display: flex;`">
                <div :style="`width: 25%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[0].picview"/>
                </div>
                <div :style="`width: 25%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[1].picview"/>
                </div>
                <div :style="`width: 25%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[2].picview"/>
                </div>
                <div :style="`width: 25%;height: ${new_data.content.height}px;`">
                    <img class="width_height_100" :src="new_data.content.imgList[3].picview"/>
                </div>
            </div>
            <div v-if="new_data.content.style_id == 7">
                <div
                    :style="`width: 100%;height: ${new_data.content.height / 2}px;display: flex;`"
                >
                    <div
                        :style="`width: 50%;height: ${new_data.content.height / 2}px;`"
                    >
                        <img class="width_height_100" :src="new_data.content.imgList[0].picview"/>
                    </div>
                    <div
                        :style="`width: 50%;height: ${new_data.content.height / 2}px;`"
                    >
                        <img class="width_height_100" :src="new_data.content.imgList[1].picview"/>
                    </div>
                </div>
                <div
                    :style="`width: 100%;height: ${new_data.content.height / 2}px;display: flex`"
                >
                    <div
                        :style="`width: 50%;height: ${new_data.content.height / 2}px;`"
                    >
                        <img class="width_height_100" :src="new_data.content.imgList[2].picview"/>
                    </div>
                    <div
                        :style="`width: 50%;height: ${new_data.content.height / 2}px;`"
                    >
                        <img class="width_height_100" :src="new_data.content.imgList[3].picview"/>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div
                :style="`height: ${new_data.content.height}px;`"
            >
                <img class="width_height_100" :src="new_data.content.picview" @dragstart.prevent/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        new_data: {
            typeof: Object,
            default: {},
        },
    },
    mounted() {
    },
};
</script>

<style scoped>
.display_flex {
    display: flex;
}
.width_height_100 {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>